import { createAsset } from './create'
import { getAssetById } from './read'

export const assets = {
  create: createAsset,
  readSingle: getAssetById,
}
